'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { getENV } from '../../../utils';
import { hasConsentGroup, onOneTrustGroupsUpdated } from '../../utils';
const SDK_LOAD_TIMEOUT_MS = 10_000;
type FormState = 'loading' | 'ready' | 'error' | 'blocked';
type UseMedalliaFormV2Params = {
  isActive?: boolean;
};
export function useMedalliaFormV2(t0) {
  const $ = _c(11);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    isActive: t2
  } = t1;
  const isActive = t2 === undefined ? true : t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = getENV();
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const {
    NEXT_PUBLIC_MEDALLIA_FORM_ID_US,
    NEXT_PUBLIC_MEDALLIA_FORM_ID_CA,
    NEXT_PUBLIC_LOCALE
  } = t3;
  const isCA = NEXT_PUBLIC_LOCALE === "en-CA";
  const formId = isCA ? NEXT_PUBLIC_MEDALLIA_FORM_ID_CA : NEXT_PUBLIC_MEDALLIA_FORM_ID_US;
  const [formState, setFormState] = useState("loading");
  let t4;
  let t5;
  if ($[3] !== isActive) {
    t4 = () => {
      if (!isActive) {
        return;
      }
      let timeoutId;
      const clearSdkWait = () => {
        if (timeoutId !== undefined) {
          clearTimeout(timeoutId);
          timeoutId = undefined;
        }
        window.removeEventListener("neb_OnsiteLoaded", handleSDKReady);
      };
      const loadFeedbackForm = groups => {
        if (!hasConsentGroup({
          group: "C0002",
          groups: groups ?? window.OnetrustActiveGroups
        })) {
          setFormState("blocked");
          return true;
        }
        if (!window.KAMPYLE_ONSITE_SDK) {
          return false;
        }
        const loadedForm = window.KAMPYLE_ONSITE_SDK.loadForm(formId);
        setFormState(loadedForm ? "ready" : "error");
        return true;
      };
      const handleSDKReady = () => {
        clearSdkWait();
        loadFeedbackForm();
      };
      const waitForSdkOrTimeout = groups_0 => {
        if (loadFeedbackForm(groups_0)) {
          clearSdkWait();
          return;
        }
        setFormState("loading");
        clearSdkWait();
        timeoutId = setTimeout(() => {
          timeoutId = undefined;
          setFormState("error");
        }, SDK_LOAD_TIMEOUT_MS);
        window.addEventListener("neb_OnsiteLoaded", handleSDKReady, {
          once: true
        });
      };
      waitForSdkOrTimeout();
      const removeConsentListener = onOneTrustGroupsUpdated(waitForSdkOrTimeout);
      return () => {
        clearSdkWait();
        removeConsentListener();
      };
    };
    t5 = [isActive, formId];
    $[3] = isActive;
    $[4] = t4;
    $[5] = t5;
  } else {
    t4 = $[4];
    t5 = $[5];
  }
  useEffect(t4, t5);
  let t6;
  if ($[6] !== isActive) {
    t6 = () => {
      if (!isActive) {
        return;
      }
      if (!hasConsentGroup({
        group: "C0002",
        groups: window.OnetrustActiveGroups
      })) {
        setFormState("blocked");
        return;
      }
      if (!window.KAMPYLE_ONSITE_SDK) {
        setFormState("error");
        return;
      }
      const openedForm = window.KAMPYLE_ONSITE_SDK.showForm(formId);
      if (!openedForm) {
        setFormState("error");
      }
    };
    $[6] = isActive;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const onOpen = t6;
  let t7;
  if ($[8] !== formState || $[9] !== onOpen) {
    t7 = {
      formState,
      onOpen
    };
    $[8] = formState;
    $[9] = onOpen;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  return t7;
}